import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";

import {
  FaBox,
  FaDesktop,
  FaChartLine,
  FaBullhorn,
  FaBuilding,
  FaFileAlt,
  FaFileInvoice,
  FaEllipsisH,
  FaTimes,
  FaUpload,
  FaCheck,
  FaInfoCircle,
  FaEdit,
  FaTrash,
  FaCoins,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { IpInfoResponse } from "../../@types/authTypes";
import { Plan } from "../../@types/pricingTypes";
import { PricingModal } from "./onboarding-sections/PricingModal";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setUserPlan } from "../../redux/slices/userSlice";
import uploadFileToS3 from "../../utils/uploadFileToS3";
// import GuidedTour from '../onboarding/shared/GuidedTour'
// import { useOutlineContext } from "../presentation-view/OutlineContext"; // Import Context API
// import GuidedTourMobile from '../onboarding/shared/GuidedTourMobile'
import { Dialog } from "@headlessui/react";
import WebsiteLinkForm from "../../components/pages/onboarding-sections/WebsiteLinkForm";
import { Theme } from "../../lib/theme";
import { useCredit } from "../..//hooks/usecredit";
import ProgressSkeleton from "../skeletons/ProgressSkeleton";
// Define an interface for colors
interface Colors {
  P100: string;
  P75_S25: string;
  P50_S50: string;
  P25_S75: string;
  S100: string;
  F_P100: string;
  F_P75_S25: string;
  F_P50_S50: string;
  F_P25_S75: string;
  F_S100: string;
  SCL: string;
  SCD: string;
}
interface SlideOutline {
  slideName?: any;
  title: string;
  type: string;
  keywords?: string;
  method?: string;
  outlineID: string;
}
const outlineTest: SlideOutline[] = [
  {
    title: "Introduction to Labor Movements",
    type: "Points",
    keywords: "Industrial revolution, Workers’ unions",
    outlineID: "outlineID-1a2b3c4d-1111-aaaa-2222-333344445555",
  },
  {
    title: "Early Struggles and Resistance",
    type: "Points",
    keywords: "Protests, Wage disputes, Exploitation",
    outlineID: "outlineID-2b3c4d5e-2222-bbbb-3333-444455556666",
  },
  {
    title: "Rise of Trade Unions",
    type: "Points",
    keywords: "Collective bargaining, Unionization",
    outlineID: "outlineID-3c4d5e6f-3333-cccc-4444-555566667777",
  },
  {
    title: "Legal Milestones in Labor Rights",
    type: "Points",
    keywords: "Labor laws, Minimum wage, Child labor bans",
    outlineID: "outlineID-4d5e6f70-4444-dddd-5555-666677778888",
  },
  {
    title: "Modern Challenges in the Workforce",
    type: "Points",
    keywords: "Gig economy, Job insecurity, Automation",
    outlineID: "outlineID-5e6f7081-5555-eeee-6666-777788889999",
  },
  {
    title: "Global Perspectives on Labor Reforms",
    type: "Points",
    keywords: "ILO, International standards, Developing nations",
    outlineID: "outlineID-6f708192-6666-ffff-7777-888899990000",
  },
  {
    title: "Conclusion and Future Outlook",
    type: "Points",
    keywords: "Sustainable labor, Equity, Digital rights",
    outlineID: "outlineID-7f8192a3-7777-aaaa-8888-999900001111",
  },
];

const supportedLanguages = [
  "English",
  "Chinese (Simplified)",
  "Chinese (Traditional)",
  "Spanish",
  "French",
  "German",
  "Portuguese (Brazilian)",
  "Portuguese (European)",
  "Italian",
  "Russian",
  "Japanese",
  "Korean",
  "Dutch",
  "Arabic (Modern Standard)",
  "Polish",
  "Turkish",
  "Vietnamese",
];

const SelectPresentationType: React.FC = () => {
  const presentationTypes = [
    { id: 1, label: "Product", icon: <FaBox className="text-[#3667B2]" /> },
    {
      id: 2,
      label: "Pitch Deck",
      icon: <FaDesktop className="text-[#3667B2]" />,
    },
    {
      id: 3,
      label: "Sales Deck",
      icon: <FaChartLine className="text-[#3667B2]" />,
    },
    {
      id: 4,
      label: "Marketing",
      icon: <FaBullhorn className="text-[#3667B2]" />,
    },
    {
      id: 5,
      label: "Company Overview",
      icon: <FaBuilding className="text-[#3667B2]" />,
    },
    {
      id: 6,
      label: "Project Proposal",
      icon: <FaFileInvoice className="text-[#3667B2]" />,
    },
    {
      id: 7,
      label: "Project Summary",
      icon: <FaFileAlt className="text-[#3667B2]" />,
    },
    {
      id: 8,
      label: "Others",
      icon: <FaEllipsisH className="text-[#3667B2]" />,
    },
  ];
  const [isRefineModalOpen, setIsRefineModalOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleColorChange = (
    key: keyof typeof brandingColors,
    color: string
  ): void => {
    setBrandingColors((prev) => ({ ...prev, [key]: color }));
  };
  const [file, setFile] = useState<File | null>(null);
  const userAgent = navigator.userAgent.toLowerCase();
  //const { setIsOutlineGenerated } = useOutlineContext(); // ✅ Use Context API
  const [pdfLink, setPdfLink] = useState("");
  const [theme, setTheme] = useState("Light");
  const [creativity, setCreativity] = useState(5);
  const [pdfUploading, setPDFUploading] = useState(false);
  const [selectedType, setSelectedType] = useState<number | null>(null);
  const [customTypeInput, setCustomTypeInput] = useState<string>("");
  const navigate = useNavigate();
  const authToken = sessionStorage.getItem("authToken");
  const orgId = sessionStorage.getItem("orgId");
  const storedPresentationId = sessionStorage.getItem("presentationId");
  const [isPricingModalOpen, setIsPricingModalOpen] = useState(false);
  const [progress, setProgress] = useState(0);
  const pricingModalHeading = "Refine PPT";
  const userPlan = useSelector((state: any) => state.user.userPlan);
  const [monthlyPlan, setMonthlyPlan] = useState<Plan>();
  const [yearlyPlan, setYearlyPlan] = useState<Plan>();
  const [currency, setCurrency] = useState("");
  const [subId, setSubId] = useState("");
  const dispatch = useDispatch();
  const [showThemeTooltip, setShowThemeTooltip] = useState(false);
  const [hoveredTheme, setHoveredTheme] = useState<string | null>(null); // Track which theme is hovered
  const [eligibleForGeneration, setEligibleForGeneration] = useState(false);
  const [pptCount, setPptCount] = useState(0);
  const [pptCountMonthly, setPptCountMonthly] = useState(0);
  // const [credits, setCredits] = useState<number>(0);
  const [outline, setOutline] = useState<SlideOutline[]>([]);
  const [hoverIndex, setHoverIndex] = useState<number | null>(null);

  const [showTooltip, setShowTooltip] = useState(false);
  const [showTooltip1, setShowTooltip1] = useState(false);
  const [showTooltip2, setShowTooltip2] = useState(false);
  const [showTooltip3, setShowTooltip3] = useState(false);
  const [showTooltip4, setShowTooltip4] = useState(false);
  const [websiteUrl, setWebsiteUrl] = useState<string>("");
  const [isHovered, setIsHovered] = useState(false);
  const [primaryColor, setPrimaryColor] = useState("#000000");
  const [textColor, setTextColor] = useState("#000000"); // Define the primary color
  const [secondaryColor, setSecondaryColor] = useState("#FFFFFF"); // Define the secondary color
  const [generateInput, setGenerateInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [isGeneratingPresentation, setIsGeneratingPresentation] =
    useState(false);

  const [generatedDocumentIDoutline, setGeneratedDocumentIDoutline] = useState<
    string | null
  >(null);
  const [brandingColors, setBrandingColors] = useState<string[]>([]); // Initialize branding colors
  const [brandingColorsSave, setBrandingColorsSave] = useState<string[]>([]); // Initialize branding colors
  const [isLoading, setIsLoading] = useState<boolean>(false); // Add a loading state
  const [isValidLink, setIsValidLink] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isgenerated, setgenerated] = useState(false);
  const [organizationColors, setOrganizationColors] = useState<Colors | null>(
    null
  );
  const urlRegex = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;
  const [language, setLanguage] = useState<string>("English");
  const [inputIndex, setInputIndex] = useState<number | null>(null);
  const [newOutline, setNewOutline] = useState<string>("");
  const [newOutlineLoading, setNewOutlineLoading] = useState(false);
  const [activeTab, setActiveTab] = useState<"outline" | "options">("options");
  const [editingIndex, setEditingIndex] = useState<number | null>(null);
  const [editedOutline, setEditedOutline] = useState<{
    title: string;
    keywords: string;
  }>({ title: "", keywords: "" });
  const [isOutlineLoading, setIsOutlineLoading] = useState<boolean>(false);
  const { credits, updateCredit, increaseCredit, decreaseCredit } = useCredit();

  const handleUpgradeCredit = (val: number) => {
    updateCredit(val);
  };
  const generateOutlineID = () => {
    return `outlineID-${window.crypto.randomUUID()}`;
  };
  const fetchOutlines = useCallback(async () => {
    if (!generatedDocumentIDoutline) return;

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/outline/${generatedDocumentIDoutline}/outline`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      const { outline: fetchedOutlines } = response.data;

      setOutline(fetchedOutlines);
    } catch (error) {
      console.error("Error fetching outlines:", error);
    }
  }, [generatedDocumentIDoutline, authToken]);

  const handleAddOutline = async (index: number) => {
    const newOutlineID = generateOutlineID();

    setNewOutlineLoading(true);
    if (!newOutline.trim()) {
      console.log("New outline is empty");
      setNewOutlineLoading(false);
      return;
    }
    const updatedOutline = { title: newOutline };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/outline/blocklist/insert`,
        {
          documentId: generatedDocumentIDoutline,
          title: updatedOutline.title,
          position: index + 1,
          outlineID: newOutlineID,
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      const result = response.data;
      if (result.title && result.type) {
        // Retrieve the existing outlineIDs array from sessionStorage
        const storedOutlineIDs = sessionStorage.getItem("outlineIDs");
        let outlineIDs = storedOutlineIDs ? JSON.parse(storedOutlineIDs) : [];

        // Add the new outlineID to the array
        outlineIDs.push(newOutlineID);

        // Save the updated array back to sessionStorage
        sessionStorage.setItem("outlineIDs", JSON.stringify(outlineIDs));
        toast.success("Outline Successfully Added", {
          position: "top-right",
          autoClose: 3000,
        });
        fetchOutlines();
        setNewOutlineLoading(false);
      }
      setInputIndex(null);
      setNewOutline("");
    } catch (error: any) {
      if (error.response && error.response.status === 404) {
        toast.error("Upgrade to add more slides", {
          position: "top-right",
          autoClose: 3000,
        });
      } else {
        toast.error("Error adding outline", {
          position: "top-right",
          autoClose: 3000,
        });
      }
      console.error("Error adding outline:", error);
      setNewOutlineLoading(false);
    }
  };

  const handleDeleteOutline = async (index: number) => {
    if (!generatedDocumentIDoutline) return;

    setOutline((prevOutlines) => {
      const updatedOutlines = [...prevOutlines];
      const deletedItem = updatedOutlines.splice(index, 1);

      (async () => {
        try {
          await axios.post(
            `${process.env.REACT_APP_BACKEND_URL}/api/v1/outline/blocklist/delete`,
            {
              documentId: generatedDocumentIDoutline,
              index,
            },
            {
              headers: {
                Authorization: `Bearer ${authToken}`,
              },
            }
          );
          toast.success("Outline deleted successfully", {
            position: "top-right",
            autoClose: 3000,
          });
        } catch (error) {
          // Rollback on failure
          setOutline((current) => {
            const rollbackOutlines = [...current];
            rollbackOutlines.splice(index, 0, deletedItem[0]);
            return rollbackOutlines;
          });

          toast.error("Failed to delete outline. Please try again.", {
            position: "top-right",
            autoClose: 3000,
          });

          console.error("Error deleting outline:", error);
        }
      })();

      return updatedOutlines;
    });
  };
  const fetchCredits = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile/organization/${orgId}`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      handleUpgradeCredit(res.data?.credits || 0);
      setUserPlan(res.data?.plan?.plan_name || "free");
    } catch (err) {
      console.error("Failed to fetch credits:", err);
      handleUpgradeCredit(0);
      setUserPlan("free");
    }
  };
  const refreshCredits = async () => {
    try {
      await axios.patch(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile/organizationedit/${orgId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      await fetchCredits();
      toast.success("Credits refreshed");
    } catch (err) {
      console.error("Failed to refresh credits:", err);
      toast.error("Credit refresh failed");
    }
  };
  const handleUpgrade = () => {
    const query = new URLSearchParams({
      authToken: authToken || "",
      userEmail: sessionStorage.getItem("userEmail") || "",
      orgId: orgId ?? "",
    });
    window.open(
      `/pricing?${query.toString()}`,
      "_blank",
      "noopener,noreferrer"
    );
  };
  const handleCloseModal = () => {
    setGeneratedDocumentIDoutline(null); // Reset ID when closing
    setIsRefineModalOpen(false);
  };
  useEffect(() => {
    if (websiteUrl) {
      setIsValidLink(urlRegex.test(websiteUrl));
    }
  }, [websiteUrl]); // Re-run validation when `websiteUrl` changes

  const generateDocumentID = () => {
    return "Document-" + Date.now();
  };
  const generatedDocumentID = generateDocumentID();

  const MAX_FILE_SIZE_MB = 20; // Limit file size to 20MB

  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setPDFUploading(true);

    if (event.target.files && event.target.files[0]) {
      const uploadedFile = event.target.files[0];

      // Check file size
      const fileSizeMB = uploadedFile.size / (1024 * 1024);
      if (fileSizeMB > MAX_FILE_SIZE_MB) {
        toast.error(
          `File size exceeds ${MAX_FILE_SIZE_MB}MB. Please upload a smaller file.`,
          {
            position: "top-right",
            autoClose: 3000,
          }
        );
        setPDFUploading(false);
        return;
      }

      setFile(uploadedFile);

      try {
        const pdfUploaded = {
          name: uploadedFile.name,
          type: uploadedFile.type,
          body: uploadedFile, // Pass the File object directly
        };
        // Handle upload
        const pdfLink = await uploadFileToS3(pdfUploaded);
        setPdfLink(pdfLink);
      } catch (error) {
        console.error("Error uploading file:", error);
        toast.error("Failed to upload file. Please try again.", {
          position: "top-right",
          autoClose: 3000,
        });
      } finally {
        setPDFUploading(false);
      }
    } else {
      setPDFUploading(false);
    }
  };

  const handleGenerate = () => {
    navigate(`/presentation-view?documentID=${generatedDocumentIDoutline}`);

    const quickGenerate = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/documentgenerate/generate-document/${orgId}/${generatedDocumentIDoutline}`,
          {
            pptInput: generateInput,
          },
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          }
        );

        await response.data;
      } catch (error: any) {
        if (error.response?.status === 404) {
          toast.error("Error generating ppt", {
            position: "top-right",
            autoClose: 3000,
          });
        }
      }
    };

    const updatePptCount = async () => {
      await axios.patch(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile/organizationedit/${orgId}`,
        {
          pptcount: pptCount + 1,
          pptcount_monthly: pptCountMonthly + 1,
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
    };

    quickGenerate();
    updatePptCount();
  };
  const handleSaveColors = async () => {
    setIsLoading(true); // Show loading state

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile//organization/updateColors/${orgId}`,
        { primaryColor, secondaryColor },
        { headers: { Authorization: `Bearer ${authToken}` } }
      );

      if (response.status === 200) {
        const colors = response.data.colors || organizationColors; // Use fetched colors if API doesn't return any

        // Convert object values into an array
        const colorMap = {
          P100: colors.P100 || "#17191A",
          P75_S25: colors.P75_S25 || "#313B48",
          P50_S50: colors.P50_S50 || "#4A5C75",
          P25_S75: colors.P25_S75 || "#647EA3",
          S100: colors.S100 || "#7D9FD0",
          F_P100: colors.F_P100 || "#E8E8E8",
          F_P75_S25: colors.F_P75_S25 || "#E4E8EC",
          F_P50_S50: colors.F_P50_S50 || "#FFFFFF",
          F_P25_S75: colors.F_P25_S75 || "#FFFFFF",
          F_S100: colors.F_S100 || "#FFFFFF",
          SCL: colors.SCL || "#FFFFFF",
          SCD: colors.SCD || "#000000",
        };
        const colorArray: string[] = [
          colors.P100,
          colors.P75_S25,
          colors.P50_S50,
          colors.P25_S75,
          colors.S100,
        ];
        const colorArraySave: string[] = [
          colors.P100,
          colors.P75_S25,
          colors.P50_S50,
          colors.P25_S75,
          colors.S100,
          colors.F_P100,
          colors.F_P75_S25,
          colors.F_P50_S50,
          colors.F_P25_S75,
          colors.F_S100,
          colors.SCL,
          colors.SCD,
        ];

        await setBrandingColors([...colorArray]); // Ensure React detects state change
        await setBrandingColorsSave([...colorArraySave]); // Ensure React detects state change
        setPrimaryColor(colorMap.P100);
        setTextColor(colorMap.F_P100);
        setSecondaryColor(colorMap.S100);
      }
    } catch (error) {
      console.error("Error updating branding colors:", error);
    } finally {
      setIsLoading(false); // Hide loading state
    }
  };

  const handleRefinePPT = () => {
    const refinePPT = async () => {
      if (!file) {
        toast.info("Please upload a PDF to refine", {
          position: "top-right",
          autoClose: 3000,
        });
        return;
      }

      navigate(`/presentation-view?documentID=${generatedDocumentIDoutline}`);

      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/documentgenerate/generate-document/refineppt/${orgId}/${generatedDocumentIDoutline}`,
          {
            pdfLink: pdfLink,
          },
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          }
        );

        await response.data;
      } catch (error: any) {}
    };

    const updatePptCount = async () => {
      await axios.patch(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile/organizationedit/${orgId}`,
        {
          pptcount: pptCount + 1,
          pptcount_monthly: pptCountMonthly + 1,
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
    };
    refinePPT();
    updatePptCount();
  };

  const isButtonDisabled =
    selectedType === 8
      ? !customTypeInput.trim() ||
        (userPlan !== "pro" && !eligibleForGeneration)
      : !selectedType || (userPlan !== "pro" && !eligibleForGeneration);

  // API CALL TO GET PRICING DATA FOR MODAL AND USER PLAN
  useEffect(() => {
    const getPricingData = async () => {
      const ipInfoResponse = await fetch("https://api.zynth.ai/api/v1/data/userprofile/ip-info");
      const ipInfoData: IpInfoResponse = await ipInfoResponse.json();

      await axios
        .get(
          `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/appscripts/razorpay/plans`,
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          }
        )
        .then((response) => {
          const country = ipInfoData!.country!;
          if (country !== "IN" && country !== "India" && country !== "In") {
            setMonthlyPlan(response.data.items[4]);
            setYearlyPlan(response.data.items[2]);
            // setMonthlyPlan(response.data.items[1])
            // setYearlyPlan(response.data.items[0])
            setCurrency("USD");
          } else if (
            country === "IN" ||
            country === "India" ||
            country === "In"
          ) {
            setMonthlyPlan(response.data.items[5]);
            setYearlyPlan(response.data.items[3]);
            // setMonthlyPlan(response.data.items[1])
            // setYearlyPlan(response.data.items[0])
            setCurrency("INR");
          }
        });
    };

    const fetchUserPlan = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile/organization/${orgId}`,
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        const planName = response.data.plan.plan_name;
        const subscriptionId = response.data.plan.subscriptionId;
        setPptCount(response.data.pptcount);
        setPptCountMonthly(response.data.pptcount_monthly);
        if (planName === "pro" || response.data.is_eligible === true) {
          setEligibleForGeneration(true);
          sessionStorage.setItem("eligibelForGeneration", "true");
        } else {
          setEligibleForGeneration(false);
          sessionStorage.setItem("eligibelForGeneration", "false");
        }
        dispatch(setUserPlan(planName));
        setSubId(subscriptionId);
      } catch (error) {
        console.error("Error fetching user plan:", error);
      }
    };

    fetchUserPlan();
    getPricingData();
  }, []);
  const monthlyPlanAmount = monthlyPlan?.item.amount! / 100;
  const monthlyPlanId = monthlyPlan?.id;
  const yearlyPlanAmount = yearlyPlan?.item.amount! / 100;
  const yearlyPlanId = yearlyPlan?.id;
  const Tooltip: React.FC<{ message: string }> = ({ message }) => {
    return (
      <div className="absolute left-8 bottom-10 w-72 bg-gray-800 text-white text-sm rounded-lg px-4 py-2 shadow-lg">
        {message}
      </div>
    );
  };
  const [visibleTooltip, setVisibleTooltip] = useState<string | null>(null);
  useEffect(() => {
    let timeout: NodeJS.Timeout;
    if (!isHovered && visibleTooltip === "generate") {
      timeout = setTimeout(() => {
        setVisibleTooltip(null);
      }, 3000);
    }
    return () => clearTimeout(timeout);
  }, [isHovered, visibleTooltip]);

  const generateOutline = async () => {
    setLoading(true);
    setIsOutlineLoading(true);

    let docID = generatedDocumentIDoutline || generateDocumentID();
    setGeneratedDocumentIDoutline(docID);
    sessionStorage.setItem("form_id", docID);
    const payload = {
      pptInput: generateInput || "",
      pdfLink: pdfLink || "",
      deviceType: userAgent,
      presentationIDs: storedPresentationId,
    };

    try {
      const requestUrl = `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/documentgenerate/generate-document/outline/${orgId}/${docID}`;

      const response = await axios.post(requestUrl, payload, {
        headers: { Authorization: `Bearer ${authToken}` },
      });

      if (response.status !== 200)
        throw new Error("Failed to generate outline");

      setOutline(response.data.outline);

      // ✅ Notify other components via Context API
      setIsOutlineGenerated(true);

      console.log("Outline generated successfully:", response.data.outline);
      setIsOutlineLoading(false);
    } catch (error) {
      if (axios.isAxiosError(error)) {
        console.error("API Error:", error.response?.data || error.message);
      } else {
        console.error("Unexpected Error:", error);
      }
      setIsOutlineLoading(false);
    } finally {
      setLoading(false);
      console.log("Device Type:", userAgent);
      setIsOutlineLoading(false);
    }
  };

  const generateDocument = async () => {
    setLoading(true);
    // navigate(
    //   `/presentation-view?documentID=${generatedDocumentIDoutline}`
    // )
    if (!generatedDocumentIDoutline) {
      console.error("Error: Document ID is missing. Generate outline first.");
      setLoading(false);
      return;
    }
    const colorsToUse = brandingColorsSave.length
      ? brandingColorsSave
      : Object.values(organizationColors || {});

    const colorKeys = [
      "P100",
      "P75_S25",
      "P50_S50",
      "P25_S75",
      "S100",
      "F_P100",
      "F_P75_S25",
      "F_P50_S50",
      "F_P25_S75",
      "F_S100",
      "SCL",
      "SCD",
    ];

    const payload = {
      websiteUrl: websiteUrl || "",
      colors: colorKeys.reduce((acc: { [key: string]: string }, key, index) => {
        acc[key] = colorsToUse[index] || "#000000"; // Default to black if missing
        return acc;
      }, {} as { [key: string]: string }),
      creativity: creativity, // Number
      theme: theme, // String
      language: language || "English",
    };

    try {
      const requestUrl = `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/documentgenerate/generate-document/${orgId}/${generatedDocumentIDoutline}`;

      console.log("Document Request URL:", requestUrl);
      console.log("Payload:", payload);

      const response = await axios.post(requestUrl, payload, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (response.status !== 200)
        throw new Error("Failed to generate document");

      const data = response.data;
      setOutline(data.outline);
      return true;
    } catch (error) {
      console.error("Document generation failed:", error);
      return false;
    } finally {
      setLoading(false);
    }
  };

  const handleButtonClick = async () => {
    // Show progress skeleton immediately
    setIsGeneratingPresentation(true);

    // Immediately navigate
    navigate("/presentation-success");

    // Optional: Start background tasks
    setLoading(true);
    setgenerated(true);
    setProgress(0);

    let localProgress = 0;
    const interval = setInterval(() => {
      localProgress += 30;
      if (localProgress >= 90) {
        localProgress = 90;
        clearInterval(interval);
      }
      setProgress(localProgress);
    }, 10000);

    // Run async in background
    const success = await generateDocument();

    if (success) {
      if (localProgress < 90) {
        setProgress(100);
      } else {
        setTimeout(() => setProgress(100), 500);
      }
      await axios.patch(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile/organizationedit/${orgId}`,
        {
          pptcount: pptCount + 1,
          pptcount_monthly: pptCountMonthly + 1,
          credits:
            userPlan == "free" && !eligibleForGeneration
              ? credits - 10
              : credits,
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
    } else {
      setLoading(false);
      setgenerated(false);
      // You may want to log error or track fail silently
    }

    // Reset the presentation generation loading state
    setIsGeneratingPresentation(false);
  };

  useEffect(() => {
    const fetchOrganizationData = async () => {
      if (!orgId) {
        console.error("Error: Organization ID is missing.");
        return;
      }

      setLoading(true);
      const requestUrl = `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile/organization/${orgId}`;

      try {
        console.log("Fetching Organization Data:", requestUrl);

        const response = await axios.get(requestUrl, {
          headers: { Authorization: `Bearer ${authToken}` },
        });

        if (response.status !== 200) {
          throw new Error(`Failed to fetch data: ${response.statusText}`);
        }

        const data = response.data;
        console.log("Fetched Organization Data:", data);

        setWebsiteUrl(data.websiteLink || "");
        if (data?.credits !== undefined) {
          handleUpgradeCredit(data.credits);
        }

        // Ensure colors exist before processing
        if (data.color && typeof data.color === "object") {
          const colorMap = {
            P100: data.color.P100 || "#000000",
            P75_S25: data.color.P75_S25 || "#290000",
            P50_S50: data.color.P50_S50 || "#520000",
            P25_S75: data.color.P25_S75 || "#7A0000",
            S100: data.color.S100 || "#a30000",
            F_P100: data.color.F_P100 || "#FFFFFF",
            F_P75_S25: data.color.F_P75_S25 || "#FFFFFF",
            F_P50_S50: data.color.F_P50_S50 || "#FFFFFF",
            F_P25_S75: data.color.F_P25_S75 || "#E9E9E9",
            F_S100: data.color.F_S100 || "#EADFF2",
            SCL: data.color.SCL || "#FFFFFF",
            SCD: data.color.SCD || "#000000",
          };

          const colorArray = [
            colorMap.P100,
            colorMap.P75_S25,
            colorMap.P50_S50,
            colorMap.P25_S75,
            colorMap.S100,
          ];

          setBrandingColors(colorArray);
          setOrganizationColors(colorMap);
          setTextColor(colorMap.F_P100);
          setPrimaryColor(colorMap.P100);
          setSecondaryColor(colorMap.S100);
        }
      } catch (error) {
        if (error instanceof Error) {
          console.error("Error fetching organization data:", error.message);
        } else {
          console.error("Error fetching organization data:", error);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchOrganizationData();
  }, [orgId, authToken]); // Dependencies

  const [showCreativityTooltip, setShowCreativityTooltip] = useState(false);
  return (
    <div className="min-h-screen w-screen bg-gradient-to-br from-[#f1f1f3] via-[#aec2e6] to-[#fafafa] overflow-y-auto flex flex-col items-center justify-start p-4">
      <div className="w-full text-center flex flex-col items-center">
        <div className="absolute inset-0 -z-10 rounded-2xl"></div>
        {/* <h2 className="text-2xl font-semibold text-gray-700 mb-8 mt -8">
          Tell us what you want to build
        </h2> */}
        <p className="text-gray-500  flex items-center gap-1 relative text-lg">
          Enter your presentation context.
          <span
            className="text-blue-500 cursor-pointer relative"
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
          >
            <FaInfoCircle className="text-[#3667B2] cursor-pointer relative" />
            {showTooltip && (
              <div className="absolute hidden lg:block left-full ml-2 mt-12  transform -translate-y-1/2 w-72 p-3 bg-gray-800 text-white text-xs rounded-lg shadow-lg opacity-100 transition-opacity duration-300 text-left z-10">
                <p className="font-semibold">
                  Provide clear details about your presentation requirements.
                  The more specific you are, the more relevant the output will
                  be.
                </p>
                <p>
                  {" "}
                  - Outline the objective and key message of the presentation.
                </p>
                <p>
                  - Specify any required slides, information, or data to
                  include.
                </p>
                <p>
                  - Provide detailed instructions to ensure alignment with your
                  vision.
                </p>
              </div>
            )}
            {showTooltip && (
              <div className="absolute top-0 lg:hidden left-[80%] -translate-x-[80%] -translate-y-[80%] w-72 p-3 bg-gray-800 text-white text-xs rounded-lg shadow-lg opacity-100 transition-opacity duration-300 text-left">
                <p className="font-semibold">
                  Provide clear details about your presentation requirements.
                  The more specific you are, the more relevant the output will
                  be.
                </p>
                <p>
                  - Outline the objective and key message of the presentation.
                </p>
                <p>
                  - Specify any required slides, information, or data to
                  include.
                </p>
                <p>
                  - Provide detailed instructions to ensure alignment with your
                  vision.
                </p>
              </div>
            )}
          </span>
        </p>
        <div className="mt-2 w-full flex justify-center">
          <div className="lg:w-1/2 w-full">
            <textarea
              className="h-[7rem] w-full py-2 px-4 rounded-xl scrollbar-none resize-none border focus:outline-none focus:ring-2"
              style={{
                color: "091220",
                backgroundColor: "#FFFFFF",
                borderColor: "#E1E3E5",
                fontFamily: "'Inter', sans-serif",
                outlineColor: "#3667B2",
              }}
              placeholder="Add text or drop content here — more details mean a more tailored presentation!"
              value={generateInput || ""}
              onChange={(e) => setGenerateInput(e.target.value)}
              minLength={file ? 0 : 100}
              maxLength={10000}
            />

            {generateInput.length > 0 && (
              <div
                className="flex justify-end mt-1 text-xs mr-2"
                style={{
                  color:
                    !file && generateInput.length < 100 ? "red" : "#000000",
                }}
              >
                {generateInput.length}
              </div>
            )}
          </div>
          {/* <textarea
            className="relative lg:w-1/2 h-[7rem]  w-full text-[#091220] py-2 px-4 rounded-xl scrollbar-none resize-none"
            placeholder="Add text or drop content here — more details mean a more tailored presentation!"
            value={generateInput || ''}
            onChange={(e) => setGenerateInput(e.target.value)}
            maxLength={10000}
          >
          
          </textarea> */}
        </div>
        <div className="border-t border-gray-300 my-8 relative w-full items-center justify-center">
          <span className="absolute top-[-15px] left-1/2 transform -translate-x-1/2  px-2 font-bold text-lg">
            or
          </span>
        </div>
        <p className="text-gray-500  mb-2 mt-2 flex items-center gap-1 relative text-lg">
          Refine an existing document.
          <span
            className="text-blue-500 cursor-pointer relative"
            onMouseEnter={() => setShowTooltip1(true)}
            onMouseLeave={() => setShowTooltip1(false)}
          >
            <FaInfoCircle className="text-[#3667B2] cursor-pointer relative" />

            {showTooltip1 && (
              <div className="absolute hidden lg:block text-left bottom-8 w-72 p-3 bg-gray-800 text-white text-xs rounded-lg shadow-lg opacity-100  transition-opacity duration-300">
                <p className="font-semibold">Refine an existing document:</p>
                <p>
                  Upload a document to refine and transform it into a visually
                  stunning presentation
                </p>
              </div>
            )}
            {showTooltip1 && (
              <div className="absolute lg:hidden text-left bottom-8 w-72 p-3 bg-gray-800 text-white text-xs rounded-lg shadow-lg opacity-100  transition-opacity duration-300">
                <p className="font-semibold">Refine an existing document:</p>
                <p>
                  Upload a document to refine and transform it into a visually
                  stunning presentation
                </p>
              </div>
            )}
          </span>
        </p>

        <div className=" w-[80%] lg:w-1/4 justify-center">
          {pdfUploading && (
            <div className="flex items-center justify-center h-[3.1rem] mt-2 bg-white border border-[#5D5F61] text-[#091220] py-2 px-4 rounded-xl">
              <span>Uploading...</span>
            </div>
          )}
          {file && !pdfUploading && (
            <div className="flex items-center justify-center h-[3.1rem] bg-white border border-[#5D5F61] text-[#091220] py-2 px-4 rounded-xl">
              <span className="text-[#5D5F61] truncate">{file.name}</span>
              <button
                className="text-[#8A8B8C] ml-2"
                onClick={() => {
                  setFile(null);
                  setPdfLink("");
                }}
              >
                <FaTimes />
              </button>
            </div>
          )}
          {!file && (
            <label className="flex items-center justify-center h-[3.1rem]  bg-white border text-[#091220] py-2 px-4 rounded-xl cursor-pointer">
              <FaUpload className="mr-2 text-[#5D5F61]" />
              <span>Upload a Document</span>
              <input
                type="file"
                accept=".pdf, .doc, .docx, .ppt, .pptx"
                className="hidden"
                onChange={handleFileChange}
              />
            </label>
          )}
        </div>
        <div
          className=" flex justify-center mt-8 relative"
          onMouseEnter={() => {
            setIsHovered(true);
          }}
          onMouseLeave={() => {
            setTimeout(() => setIsHovered(false), 3000); // Hide after 3 seconds
          }}
        >
          <button
            id="generate-presentation"
            onClick={() => {
              setIsRefineModalOpen(true);
              generateOutline(); // Call the function
            }}
            disabled={
              (!file && !generateInput) ||
              (!file && generateInput && generateInput.length < 100) ||
              pdfUploading ||
              // !eligibleForGeneration ||
              (userPlan == "free" && credits < 10 && !eligibleForGeneration)
            }
            className={`h-[3.1rem] text-white px-16 py-4 rounded-lg font-semibold active:scale-95 transition transform duration-300 flex items-center justify-center ${
              (!file && !generateInput) ||
              (!file && generateInput && generateInput.length < 100) ||
              pdfUploading ||
              (userPlan == "free" && credits < 10 && !eligibleForGeneration)
                ? "bg-gray-500 cursor-not-allowed"
                : "bg-[#3667B2] hover:bg-[#0A8568]"
            }`}
          >
            Submit
          </button>
          {userPlan == "free" && !eligibleForGeneration && (
            <div className="absolute top-0 right-0 bg-[#091220] text-white text-xs px-1  rounded-tr-lg rounded-bl-lg flex items-center gap-1">
              <FaCoins className="text-yellow-400 text-sm" /> 10 Credits
            </div>
          )}
          {isHovered && (
            <>
              {!file && generateInput.length < 100 ? (
                <div className="absolute top-[80%] left-[50%] mt-2 w-[14rem] bg-gray-200 text-black p-2 rounded-2xl shadow-lg flex items-center justify-center opacity-100 transition-opacity duration-300">
                  <p className="text-sm text-center text-gray-800">
                    Please provide minimum 100 characters in presentation
                    context or Upload a document.
                  </p>
                </div>
              ) : // :
              // (!eligibleForGeneration && credits<10)? null
              // (
              //   <div className="absolute top-full mt-2 w-[14rem] bg-gray-200 text-black p-2 rounded-2xl shadow-lg flex items-center justify-center opacity-100 transition-opacity duration-300">
              //     <p className="text-sm text-center text-gray-800">
              //       Please{" "}
              //       <span
              //         onClick={() => setIsPricingModalOpen(true)}
              //         className="text-blue-600 font-semibold hover:underline cursor-pointer"
              //       >
              //         upgrade
              //       </span>{" "}
              //       to generate more presentations or get more credits.
              //     </p>
              //   </div>
              // )
              null}
            </>
          )}

          {/* {!eligibleForGeneration && isHovered && (
            <div className="absolute top-full  mt-2 w-[14rem] bg-gray-200 text-black p-2 rounded-2xl shadow-lg flex items-center justify-center opacity-100 transition-opacity duration-300">
              <p className="text-sm text-center text-gray-800">
                Please{" "}
                <span
                  onClick={() => setIsPricingModalOpen(true)}
                  className="text-blue-600 font-semibold hover:underline cursor-pointer"
                >
                  upgrade
                </span>{" "}
                to generate more presentations.
              </p>
            </div>
          )} */}
        </div>
        {userPlan === "free" && !eligibleForGeneration && (
          <div className="flex flex-col justify-center items-center text-sm mt-5 px-1 gap-3">
            <div className="text-gray-800 font-medium flex items-center gap-1">
              <FaCoins className="text-yellow-400" />
              <span>Credits Available: {credits}</span>
            </div>

            <div className="text-gray-800 font-medium">
              <button
                onClick={refreshCredits}
                className="text-md text-blue-500 underline flex items-center gap-1"
              >
                ↻ Refresh Credits
              </button>
            </div>

            <div className="text-red-600 font-medium">
              <button
                className="text-blue-600 flex items-center gap-1"
                onClick={handleUpgrade}
              >
                Get More Credits or Upgrade <span>→</span>
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Pricing Modal */}
      {isPricingModalOpen && userPlan === "free" ? (
        <PricingModal
          closeModal={() => {
            setIsPricingModalOpen(false);
          }}
          heading={pricingModalHeading}
          subscriptionId={subId}
          monthlyPlanAmount={monthlyPlanAmount}
          yearlyPlanAmount={yearlyPlanAmount}
          currency={currency}
          monthlyPlanId={monthlyPlanId!}
          yearlyPlanId={yearlyPlanId!}
          authToken={authToken!}
          orgId={orgId!}
        />
      ) : (
        <></>
      )}

      {/* Refine Modal */}
      {isRefineModalOpen && (
        <div
          className="fixed inset-0 z-10 flex justify-center items-center"
          style={{ backgroundColor: "rgba(23, 25, 26, 0.3)" }}
        >
          <div
            className="relative w-[80%] h-[90%] max-w-6xl bg-white rounded-2xl shadow-xl p-6 flex flex-col"
            style={{ backgroundColor: Theme.colors.background }}
          >
            {/* Close Button */}
            <button
              title="CloseModal"
              onClick={handleCloseModal}
              className="absolute top-4 right-4 p-2 bg-gray-200 rounded-full z-10"
            >
              <FaTimes style={{ color: Theme.colors.text.weak }} />
            </button>

            {/* Header with Tabs and Generate Button */}
            <div className="flex w-full items-center justify-between border-b border-gray-300 mb-4">
              {/* Tabs Container */}
              <div className="flex items-center">
                <button
                  onClick={() => setActiveTab("outline")}
                  className={`py-2 px-4 font-semibold transition-all ${
                    activeTab === "outline"
                      ? "border-b-4 border-blue-600 text-blue-600"
                      : "text-gray-500 hover:text-blue-600"
                  }`}
                >
                  Presentation Outline
                </button>
                <button
                  onClick={() => setActiveTab("options")}
                  className={`py-2 px-4 font-semibold transition-all ${
                    activeTab === "options"
                      ? "border-b-4 border-blue-600 text-blue-600"
                      : "text-gray-500 hover:text-blue-600"
                  }`}
                >
                  Presentation Options
                </button>
              </div>
            </div>

            <div className="w-full h-full overflow-y-auto scrollbar-none mt-2">
              {activeTab === "outline" ? (
                <div className="space-y-4  pr-2 max-h-full">
                  {isOutlineLoading ? (
                    <div className="flex flex-col justify-center items-center py-10">
                      <ul className="space-y-6 w-full">
                        {Array.from({ length: 5 }).map((_, idx) => (
                          <li key={idx} className="relative w-full">
                            <div className="border w-full border-gray-200 p-4 rounded-md shadow-sm bg-white flex flex-col gap-2 animate-pulse">
                              <div className="h-5 bg-gray-200 rounded w-2/3"></div>
                              <div className="h-4 bg-gray-100 rounded w-1/3"></div>
                            </div>
                          </li>
                        ))}
                      </ul>
                      {/* <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                      <p className="text-base">Outline Generating</p> */}
                    </div>
                  ) : (
                    <div className="flex flex-col max-h-[70vh]">
                      <div className="flex-1 overflow-y-auto pr-1">
                        <ul className="space-y-6">
                          {outline?.map((slide: any, idx: number) => (
                            <React.Fragment key={slide.outlineID}>
                              <li className="relative group">
                                <div className="relative border border-gray-200 p-4 rounded-md shadow-sm bg-white flex flex-col gap-2 transition-all duration-200 hover:shadow-md hover:border-gray-300">
                                  {editingIndex !== idx && (
                                    <div className="absolute top-2 right-2 flex space-x-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                                      <button
                                        onClick={() => {
                                          setEditingIndex(idx);
                                          setEditedOutline({
                                            title: slide.title,
                                            keywords: slide.keywords || "",
                                          });
                                        }}
                                        title="Edit"
                                        className="transition-all duration-200 hover:scale-110"
                                      >
                                        <FaEdit
                                          className="text-gray-500 hover:text-blue-600 transition-colors duration-200"
                                          style={{ fontSize: "1rem" }}
                                        />
                                      </button>
                                      <button
                                        onClick={() => handleDeleteOutline(idx)}
                                        title="Delete"
                                        className="transition-all duration-200 hover:scale-110"
                                      >
                                        <FaTrash
                                          className="text-gray-500 hover:text-red-500 transition-colors duration-200"
                                          style={{ fontSize: "1rem" }}
                                        />
                                      </button>
                                    </div>
                                  )}

                                  {editingIndex === idx ? (
                                    <div className="flex flex-col gap-3">
                                      <input
                                        value={editedOutline.title}
                                        onChange={(e) =>
                                          setEditedOutline({
                                            ...editedOutline,
                                            title: e.target.value,
                                          })
                                        }
                                        placeholder="Title"
                                        className="p-2 border border-gray-300 rounded-md transition-all duration-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
                                      />
                                      <input
                                        value={editedOutline.keywords}
                                        onChange={(e) =>
                                          setEditedOutline({
                                            ...editedOutline,
                                            keywords: e.target.value,
                                          })
                                        }
                                        placeholder="Keywords"
                                        className="p-2 border border-gray-300 rounded-md transition-all duration-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
                                      />
                                      <div className="flex gap-3">
                                        <button
                                          className="text-white bg-blue-600 px-4 py-2 rounded-md hover:bg-blue-700 transition-all duration-200"
                                          onClick={async () => {
                                            if (
                                              editedOutline.title ===
                                                slide.title &&
                                              editedOutline.keywords ===
                                                (slide.keywords || "")
                                            ) {
                                              setEditingIndex(null);
                                              return;
                                            }

                                            const updated = [...outline];
                                            updated[idx] = {
                                              ...slide,
                                              title: editedOutline.title,
                                              keywords: editedOutline.keywords,
                                            };
                                            setOutline(updated);
                                            setEditingIndex(null);

                                            try {
                                              await axios.post(
                                                `${process.env.REACT_APP_BACKEND_URL}/api/v1/outline/blocklist/update`,
                                                {
                                                  documentId:
                                                    generatedDocumentIDoutline,
                                                  blockItem: {
                                                    outlineID: slide.outlineID,
                                                    title: editedOutline.title,
                                                    keywords:
                                                      editedOutline.keywords,
                                                  },
                                                },
                                                {
                                                  headers: {
                                                    Authorization: `Bearer ${authToken}`,
                                                  },
                                                }
                                              );
                                            } catch (error) {
                                              console.error(
                                                "Update failed",
                                                error
                                              );
                                            }
                                          }}
                                        >
                                          Save
                                        </button>
                                        <button
                                          className="text-gray-700 border border-gray-300 px-4 py-2 rounded-md hover:bg-gray-100 transition-all duration-200"
                                          onClick={() => setEditingIndex(null)}
                                        >
                                          Cancel
                                        </button>
                                      </div>
                                    </div>
                                  ) : (
                                    <>
                                      <h3 className="text-lg font-semibold text-gray-800">
                                        {slide.title}
                                      </h3>
                                      {slide.keywords && (
                                        <p className="text-sm text-gray-600">
                                          <span className="font-medium">
                                            Keywords:
                                          </span>{" "}
                                          {slide.keywords}
                                        </p>
                                      )}
                                    </>
                                  )}
                                </div>

                                {idx > -1 && (
                                  <div className="mt-4 flex items-center justify-center space-x-4 relative hidden group-hover:flex">
                                    <div className="flex-grow h-px bg-gray-300"></div>

                                    <div className="relative">
                                      <button
                                        className="w-8 h-8 flex items-center justify-center rounded-full border border-gray-400 bg-white text-gray-500 hover:bg-gray-100 hover:border-gray-500 transition-all duration-200 hover:scale-110"
                                        onClick={() => setInputIndex(idx)}

                                         title="Add new section"
                                      >
                                        +
                                      </button>
                                    </div>

                                    <div className="flex-grow h-px bg-gray-300"></div>
                                  </div>
                                )}
                              </li>

                              {inputIndex === idx && (
                                <div className="border border-gray-200 p-4 rounded-md shadow-sm bg-white flex flex-col gap-3 -mt-2">
                                  <input
                                    type="text"
                                    value={newOutline}
                                    onChange={(e) =>
                                      setNewOutline(e.target.value)
                                    }
                                    placeholder="Title"
                                    className="p-2 border border-gray-300 rounded-md focus:outline-none focus:border-black focus:ring-1 focus:ring-black transition-all duration-200"
                                    autoFocus
                                  />

                                  <div className="flex gap-3">
                                    <button
                                      className="text-white bg-blue-600 px-4 py-2 rounded-md hover:bg-blue-700 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                                      onClick={() => handleAddOutline(idx)}
                                      disabled={!newOutline.trim()}
                                    >
                                      {newOutlineLoading ? (
                                        <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                                      ) : (
                                        "Add"
                                      )}
                                    </button>
                                    <button
                                      className="text-gray-700 border border-gray-300 px-4 py-2 rounded-md hover:bg-gray-100 transition-all duration-200"
                                      onClick={() => {
                                        setInputIndex(null);
                                        setNewOutline("");
                                      }}
                                    >
                                      Cancel
                                    </button>
                                  </div>
                                </div>
                              )}
                            </React.Fragment>
                          ))}
                        </ul>
                      </div>
                      <div className="flex w-full justify-center mt-4">
                        <button
                          disabled={
                            isLoading || (websiteUrl.length > 0 && !isValidLink)
                          }
                          onClick={handleButtonClick}
                          className={`lg:w-1/2 w-[80%] py-2 rounded-lg font-semibold active:scale-95 transition transform duration-300 ${
                            isLoading || (websiteUrl.length > 0 && !isValidLink)
                              ? "cursor-not-allowed"
                              : "hover:opacity-90"
                          }`}
                          style={{
                            backgroundColor:
                              isLoading ||
                              (websiteUrl.length > 0 && !isValidLink)
                                ? Theme.colors.stroke.weak
                                : Theme.colors.primary,
                            color:
                              isLoading ||
                              (websiteUrl.length > 0 && !isValidLink)
                                ? Theme.colors.text.weak
                                : "#FFFFFF",
                          }}
                        >
                          Generate Presentation
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <>
                  <div className="flex flex-col overflow-y-auto pr-2 max-h-full">
                    {/* Scrollable Form Content */}
                    <div className="flex-1 overflow-y-auto space-y-6 px-1">
                      {/* Reference Web URL + Language Side-by-Side on lg */}
                      <div className="flex flex-col lg:flex-row gap-6">
                        {/* Reference Web URL */}
                        <div className="flex-1 space-y-2">
                          <label
                            className="font-semibold flex items-center gap-2"
                            style={{ color: Theme.colors.text.strong }}
                          >
                            Reference Web URL (optional)
                            <span
                              className="cursor-pointer relative"
                              style={{ color: Theme.colors.primary }}
                              onMouseEnter={() => setShowTooltip3(true)}
                              onMouseLeave={() => setShowTooltip3(false)}
                            >
                              <FaInfoCircle className="text-base" />
                              {showTooltip3 && (
                                <div
                                  className="absolute text-left top-[7%] left-[90%] w-72 p-3 text-xs rounded-lg shadow-lg transform -translate-x-1/2 transition-opacity duration-300 opacity-100 z-50"
                                  style={{
                                    backgroundColor: Theme.colors.grounding,
                                    color: Theme.colors.background,
                                  }}
                                >
                                  <p className="font-semibold">
                                    Why add a reference URL?
                                  </p>
                                  <p>
                                    Provide a web URL from which you would like
                                    us to include information for the
                                    presentation.
                                  </p>
                                </div>
                              )}
                            </span>
                          </label>

                          <input
                            type="text"
                            value={websiteUrl}
                            onChange={(e) => {
                              const updatedValue = e.target.value;
                              if (updatedValue === "") {
                                setWebsiteUrl("");
                                setIsValidLink(true);
                                return;
                              }
                              setWebsiteUrl(updatedValue);
                              const urlRegex =
                                /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;
                              setIsValidLink(urlRegex.test(updatedValue));
                            }}
                            onFocus={() => {
                              if (!websiteUrl) setWebsiteUrl("https://");
                            }}
                            className={`w-full p-2 border rounded-lg shadow-sm outline-none focus:ring-2 ${
                              websiteUrl.length > 0 && !isValidLink
                                ? "border-red-500 focus:ring-red-500"
                                : "border-gray-300 focus:ring-[#3667B2]"
                            }`}
                            placeholder="Enter website URL"
                          />
                          {websiteUrl.length > 0 && !isValidLink && (
                            <p className="text-red-500 text-sm">
                              Please enter a valid website link.
                            </p>
                          )}
                        </div>

                        {/* Language */}
                        <div className="flex-1 space-y-2">
                          <label className="font-semibold flex items-center gap-2">
                            Language (optional)
                            {/* <span className="cursor-pointer text-primary">
                              <FaInfoCircle style={{
                                color:Theme.colors.primary
                              }} />
                            </span> */}
                          </label>
                          <select
                            title="Language"
                            value={language}
                            onChange={(e) => setLanguage(e.target.value)}
                            className="w-full p-2 border rounded-lg shadow-sm focus:ring-2 focus:outline-none border-gray-300 focus:ring-[#3667B2]"
                          >
                            <option value="">Select a language</option>
                            {supportedLanguages.map((lang) => (
                              <option key={lang} value={lang}>
                                {lang}
                              </option>
                            ))}
                          </select>
                          {language &&
                            !supportedLanguages.includes(language) && (
                              <p className="text-red-500 text-sm">
                                Unsupported language selected.
                              </p>
                            )}
                        </div>
                      </div>
                      <div className="space-y-6">
                        {/* Branding Colors */}
                        <div>
                          <div className="flex items-center relative">
                            <label
                              className="font-semibold"
                              style={{ color: Theme.colors.text.strong }}
                            >
                              Branding Colors
                            </label>
                            <div
                              className="relative flex items-center ml-2"
                              onMouseEnter={() => setShowTooltip4(true)}
                              onMouseLeave={() => setShowTooltip4(false)}
                            >
                              <FaInfoCircle
                                className="cursor-pointer"
                                style={{ color: Theme.colors.primary }}
                              />
                              {showTooltip4 && (
                                <div
                                  className="hidden lg:absolute lg:block lg:text-left lg:left-1/2 lg:bottom-8 lg:w-72 lg:p-3 text-xs rounded-lg shadow-lg lg:transform lg:-translate-x-1/2 transition-opacity duration-300 lg:opacity-100"
                                  style={{
                                    backgroundColor: Theme.colors.grounding,
                                    color: Theme.colors.background,
                                  }}
                                >
                                  <p className="font-semibold">
                                    Branding Colors
                                  </p>
                                  <p>
                                    These are the colors that will be used in
                                    your presentation. If you've uploaded a
                                    logo, the colors have been extracted from
                                    it.
                                  </p>
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="flex justify-between items-center gap-2 lg:gap-0 mt-4 w-full">
                            <div
                              className="flex w-2/3 h-10 rounded-lg overflow-hidden border-2 shadow-md"
                              style={{
                                borderColor: Theme.colors.stroke.weak,
                              }}
                            >
                              {isLoading ? (
                                <p
                                  className="flex items-center justify-center w-full"
                                  style={{ color: Theme.colors.text.weak }}
                                >
                                  Loading colors...
                                </p>
                              ) : (
                                brandingColors?.map((color, index) => (
                                  <div
                                    key={index}
                                    className="h-full flex-1"
                                    style={{ backgroundColor: color }}
                                  />
                                ))
                              )}
                            </div>

                            <button
                              className={`lg:h-[2.5rem] text-xs font-medium px-4 py-2 rounded-md active:scale-95 transition transform duration-300 ${
                                isLoading ? "opacity-50 cursor-not-allowed" : ""
                              }`}
                              style={{
                                backgroundColor: Theme.colors.background,
                                color: Theme.colors.primary,
                                border: `1px solid ${Theme.colors.primary}`,
                              }}
                              disabled={isLoading}
                              onClick={() => {
                                !isLoading && setIsModalOpen(true);
                                console.log(isLoading);
                              }}
                            >
                              Change branding colors
                            </button>
                          </div>
                        </div>
                        {/* Theme Selection */}
                        <div
                          className="flex flex-col space-y-3 p-4 rounded-lg shadow-sm"
                          style={{
                            backgroundColor: Theme.colors.stroke.weak,
                          }}
                        >
                          {/* Label with Relaxed Hover Tooltip */}
                          <div className="relative w-max">
                            <label
                              className="font-semibold flex items-center gap-2"
                              style={{ color: Theme.colors.text.strong }}
                            >
                              Choose a Theme
                              <span
                                className="cursor-pointer relative"
                                onMouseEnter={() => setShowThemeTooltip(true)}
                                onMouseLeave={() => setShowThemeTooltip(false)}
                                style={{ color: Theme.colors.primary }}
                              >
                                <FaInfoCircle className="text-base" />
                                {showThemeTooltip && (
                                  <div
                                    className="hidden lg:absolute lg:block text-left left-1/2 bottom-8 w-72 p-3 text-xs rounded-lg shadow-lg opacity-100 transform -translate-x-1/2 transition-opacity duration-300"
                                    style={{
                                      backgroundColor: Theme.colors.grounding,
                                      color: Theme.colors.background,
                                    }}
                                  >
                                    <p className="font-semibold">
                                      How do themes work?
                                    </p>
                                    <p>
                                      Choose how your slides will appear. All
                                      themes incorporate your brand colors for
                                      text and accents.
                                    </p>
                                  </div>
                                )}
                              </span>
                            </label>
                          </div>

                          <div className="flex justify-between mt-2 gap-3">
                            {[
                              {
                                name: "Light",
                                backgroundColor: Theme.colors.background,
                                textColor: Theme.colors.text.default,
                                borderColor: Theme.colors.stroke.weak,
                                tooltip:
                                  "White background with brand colors for text & accents.",
                              },
                              {
                                name: "Dark",
                                backgroundColor: Theme.colors.grounding,
                                textColor: Theme.colors.background,
                                borderColor: Theme.colors.stroke.strong,
                                tooltip:
                                  "Black background with brand colors for text & accents.",
                              },
                              {
                                name: "Branded",
                                backgroundColor: primaryColor,
                                textColor: textColor,
                                borderColor: primaryColor,
                                tooltip:
                                  "Background in your brand’s main color.",
                              },
                            ].map(
                              ({
                                name,
                                backgroundColor,
                                textColor,
                                borderColor,
                                tooltip,
                              }) => (
                                <div
                                  key={name}
                                  className="relative w-1/3"
                                  onMouseEnter={() => setHoveredTheme(name)}
                                  onMouseLeave={() => setHoveredTheme(null)}
                                >
                                  <button
                                    onClick={() => setTheme(name)}
                                    className={`w-full py-2 rounded-lg border-2 font-semibold text-center transition-all ${
                                      theme === name
                                        ? "scale-105 shadow-md"
                                        : ""
                                    } hover:scale-105 hover:shadow-lg`}
                                    style={{
                                      backgroundColor,
                                      color: textColor,
                                      borderColor:
                                        theme === name
                                          ? Theme.colors.primary
                                          : borderColor,
                                    }}
                                  >
                                    {name}
                                  </button>

                                  {/* Tooltip for Individual Themes */}
                                  {hoveredTheme === name && (
                                    <div
                                      className="hidden lg:absolute lg:bottom-full lg:left-1/2 lg:transform lg:-translate-x-1/2 lg:mb-2 w-max rounded px-3 py-2 shadow-lg opacity-100 transition-opacity duration-200 text-xs"
                                      style={{
                                        backgroundColor: Theme.colors.grounding,
                                        color: Theme.colors.background,
                                      }}
                                    >
                                      {tooltip}
                                    </div>
                                  )}
                                </div>
                              )
                            )}
                          </div>
                        </div>

                        {/* Creativity Slider */}
                        <div
                          className="flex flex-col space-y-3 p-4 rounded-lg shadow-sm"
                          style={{
                            backgroundColor: Theme.colors.stroke.weak,
                          }}
                        >
                          {/* Label, Info Icon, and Value Display */}
                          <div className="flex justify-between items-center">
                            <div className="flex items-center gap-2 relative">
                              <label
                                className="font-semibold"
                                style={{ color: Theme.colors.text.strong }}
                              >
                                Adjust Creativity
                              </label>

                              <span
                                className="cursor-pointer relative"
                                onMouseEnter={() =>
                                  setShowCreativityTooltip(true)
                                }
                                onMouseLeave={() =>
                                  setShowCreativityTooltip(false)
                                }
                                style={{ color: Theme.colors.primary }}
                              >
                                <FaInfoCircle className="text-base" />
                                {showCreativityTooltip && (
                                  <div
                                    className="hidden lg:absolute lg:block text-left left-1/2 bottom-8 w-72 p-3 text-xs rounded-lg shadow-lg opacity-100 transform -translate-x-1/2 transition-opacity duration-300"
                                    style={{
                                      backgroundColor: Theme.colors.grounding,
                                      color: Theme.colors.background,
                                    }}
                                  >
                                    <p className="font-semibold">
                                      How does Creativity affect text?
                                    </p>
                                    <p>
                                      Adjust how creative or structured the
                                      generated text should be. A higher value
                                      results in more varied and expressive
                                      wording, while a lower value keeps it
                                      concise and predictable.
                                    </p>
                                  </div>
                                )}
                              </span>
                            </div>

                            <span
                              className="font-medium"
                              style={{ color: Theme.colors.text.strong }}
                            >
                              Creativity: {creativity.toFixed(1)}
                            </span>
                          </div>

                          {/* Styled Slider */}
                          <input
                            type="range"
                            min="0"
                            max="10"
                            step="0.1"
                            value={creativity}
                            onChange={(e) => {
                              let newValue = Number(e.target.value);
                              newValue = Math.max(0, Math.min(10, newValue)); // Keep within range
                              setCreativity(newValue);
                            }}
                            className="w-full h-2 rounded-lg transition-all appearance-none "
                            style={{
                              background: `linear-gradient(to right, ${
                                Theme.colors.primary
                              } ${(creativity / 10) * 100}%, white ${
                                (creativity / 10) * 100
                              }%)`,
                              color: Theme.colors.primary,
                            }}
                          />

                          {/* Indicator Bar with Tooltips */}
                          <div
                            className="flex justify-between text-xs font-medium mt-2"
                            style={{ color: Theme.colors.text.weak }}
                          >
                            <div className="relative group">
                              <span
                                className={creativity === 0 ? "font-bold" : ""}
                                style={{
                                  color:
                                    creativity === 0
                                      ? Theme.colors.primary
                                      : undefined,
                                }}
                              >
                                Most Structured
                              </span>
                              <div
                                className="hidden lg:absolute lg:top-full lg:left-1/2 lg:transform lg:-translate-x-1/2 lg:mt-2 w-max text-xs rounded px-3 py-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 shadow-lg"
                                style={{
                                  backgroundColor: Theme.colors.grounding,
                                  color: Theme.colors.background,
                                }}
                              >
                                Highly precise and factual text with minimal
                                variation.
                              </div>
                            </div>

                            <div className="relative group">
                              <span
                                className={
                                  creativity >= 4.5 && creativity <= 5.5
                                    ? "font-bold"
                                    : ""
                                }
                                style={{
                                  color:
                                    creativity >= 4.5 && creativity <= 5.5
                                      ? Theme.colors.primary
                                      : undefined,
                                }}
                              >
                                Balanced
                              </span>
                              <div
                                className="hidden lg:absolute lg:top-full lg:left-1/2 lg:transform lg:-translate-x-1/2 lg:mt-2 w-max text-xs rounded px-3 py-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 shadow-lg"
                                style={{
                                  backgroundColor: Theme.colors.grounding,
                                  color: Theme.colors.background,
                                }}
                              >
                                A mix of structured content with slight
                                variations for engagement.
                              </div>
                            </div>

                            <div className="relative group">
                              <span
                                className={creativity === 10 ? "font-bold" : ""}
                                style={{
                                  color:
                                    creativity === 10
                                      ? Theme.colors.primary
                                      : undefined,
                                }}
                              >
                                Most Creative
                              </span>
                              <div
                                className="hidden lg:absolute lg:top-full lg:left-1/2 lg:transform lg:-translate-x-1/2 lg:mt-2 w-max text-xs rounded px-3 py-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 shadow-lg"
                                style={{
                                  backgroundColor: Theme.colors.grounding,
                                  color: Theme.colors.background,
                                }}
                              >
                                Free-flowing, expressive text with maximum
                                variation.
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="flex w-full justify-center mt-4">
                      <button
                        disabled={
                          isLoading || (websiteUrl.length > 0 && !isValidLink)
                        }
                        onClick={handleButtonClick}
                        className={`lg:w-1/2 w-[80%] py-2 rounded-lg font-semibold active:scale-95 transition transform duration-300 ${
                          isLoading || (websiteUrl.length > 0 && !isValidLink)
                            ? "cursor-not-allowed"
                            : "hover:opacity-90"
                        }`}
                        style={{
                          backgroundColor:
                            isLoading || (websiteUrl.length > 0 && !isValidLink)
                              ? Theme.colors.stroke.weak
                              : Theme.colors.primary,
                          color:
                            isLoading || (websiteUrl.length > 0 && !isValidLink)
                              ? Theme.colors.text.weak
                              : "#FFFFFF",
                        }}
                      >
                        Generate Presentation
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      )}
      {/* Color Selection Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex justify-center items-center z-[40]">
          <div className="bg-white p-6 rounded-2xl shadow-lg w-[90%] max-w-md relative">
            <h2 className="text-xl font-bold text-[#091220] mb-4 text-center">
              Select Branding Colors
            </h2>

            <div className="space-y-4">
              {/* Primary Color */}
              <div className="grid grid-cols-3 items-center gap-2">
                <label className="font-semibold text-gray-700">
                  Primary Color:
                </label>
                <input
                  type="text"
                  value={primaryColor}
                  onChange={(e) => setPrimaryColor(e.target.value)}
                  className="w-24 p-2 border border-gray-300 rounded-lg text-center shadow-sm focus:ring-2 focus:ring-[#3667B2] outline-none"
                />
                <div className="relative w-12 h-12">
                  <input
                    type="color"
                    value={primaryColor}
                    onChange={(e) => setPrimaryColor(e.target.value)}
                    className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                  />
                  <div
                    className="w-12 h-12 rounded-full border border-gray-300 shadow-md cursor-pointer transition-transform hover:scale-110"
                    style={{ backgroundColor: primaryColor }}
                  />
                </div>
              </div>

              {/* Secondary Color */}
              <div className="grid grid-cols-3 items-center gap-2">
                <label className="font-semibold text-gray-700">
                  Secondary Color:
                </label>
                <input
                  type="text"
                  value={secondaryColor}
                  onChange={(e) => setSecondaryColor(e.target.value)}
                  className="w-24 p-2 border border-gray-300 rounded-lg text-center shadow-sm focus:ring-2 focus:ring-[#3667B2] outline-none"
                />
                <div className="relative w-12 h-12">
                  <input
                    type="color"
                    value={secondaryColor}
                    onChange={(e) => setSecondaryColor(e.target.value)}
                    className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                  />
                  <div
                    className="w-12 h-12 rounded-full border border-gray-300 shadow-md cursor-pointer transition-transform hover:scale-110"
                    style={{ backgroundColor: secondaryColor }}
                  />
                </div>
              </div>
            </div>

            {/* Modal Buttons */}
            <div className="mt-6 flex justify-end space-x-4">
              <button
                className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-all"
                onClick={() => setIsModalOpen(false)}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 bg-[#3667B2] text-white rounded-lg hover:bg-[#274b8a] transition-all shadow-md"
                onClick={() => {
                  handleSaveColors();
                  setIsModalOpen(false);
                }}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
      {/* <GuidedTour />
      <GuidedTourMobile /> */}

      {/* Progress Skeleton - Show when generating presentation */}
      {isGeneratingPresentation && <ProgressSkeleton />}
    </div>
  );
};

export default SelectPresentationType;
const onOutlineSuccess = (success: boolean) => {
  if (success) {
    toast.success("Outline generated successfully!", {
      position: "top-right",
      autoClose: 3000,
    });
  } else {
    toast.error("Failed to generate outline. Please try again.", {
      position: "top-right",
      autoClose: 3000,
    });
  }
};

function setIsOutlineGenerated(arg0: boolean) {
  throw new Error("Function not implemented.");
}
